<template>
  <div class="hard-node hard-wrap">
    <BasiceLayout
      class="margin-top-20"
      title="标准节点提交"
    >
      <div
        class="button button dail-button"
        @click="checkAdd"
      >添加节点</div>
      <el-table
        v-if="nodeConfig !== 'NODATA'"
        :data="nodeConfig"
        align="left"
        empty-text="Loading..."
        style="width: 100%"
      >
        <!-- serverID -->
        <el-table-column
          prop="serverID"
          label="serverID"
          align='center'
        >
        </el-table-column>
        <!-- 节点资源类型 -->
        <el-table-column
          label="节点资源类型"
          align='center'
        >
          <template slot-scope="scope">
            <div v-if="scope.row.serverNetType == 0">静态IP专线（1Gbps / 10Gbps）</div>
            <div v-if="scope.row.serverNetType == 1">动态IP汇聚（3Gbps - 5Gbps）</div>
          </template>
        </el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="serverNote"
          label="备注"
          align='center'
          
        >
        </el-table-column>
        <!-- 节点带宽 -->
        <el-table-column
          prop="bandwidthMb"
          label="节点带宽"
          align='center'
        >
        </el-table-column>
        <!-- 拨号配置 -->
        <el-table-column
          label="拨号配置"
          align='center'
        >
          <template slot-scope="scope">
            <!-- 静态配置不需要进行拨号配置 -->
            <div v-if="scope.row.serverNetType == 0">-</div>
            <div v-if="scope.row.serverNetType == 1 && scope.row.serverConfigID && scope.row.serverConfigID != 0">{{dialNames[scope.row.serverConfigID]}}</div>
            <el-select
              class="dial-input"
              v-if="scope.row.serverNetType == 1 && (!scope.row.serverConfigID || scope.row.serverConfigID == 0) && newDialConfig.length"
              v-model="dialArray[scope.$index]"
              placeholder="请选择"
            >
              <el-option
                v-for="item in newDialConfig"
                v-if="item.dialStatus == 0"
                :label="item.dialConfigName"
                :value="item.dialConfigID"
              >
              </el-option>
            </el-select>
            <div v-if="scope.row.serverNetType == 1 && (!scope.row.serverConfigID || scope.row.serverConfigID == 0 ) && (!newDialConfig.length)">
              <a href="/dialConfig">前往拨号配置</a>
            </div>
          </template>
        </el-table-column>
        <!-- 状态-->
        <el-table-column
          label="状态"
          align='center'
        >
          <template slot-scope="scope">
            <div
              :class="['node-edit-tips', 'text-align-center', {'bonus-tip' : (scope.row.serverDeployStatus > 3  && scope.row.serverDeployStatus < 10)}]"
            >{{STATUS[scope.row.serverDeployStatus]}}</div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          align='center'
        >
          <template slot-scope="scope">
            <!-- -1 -->
            <!-- 1,2,3,9,10 不可操作 -->
            <!-- 0-未提交，可操作 -->
            <!-- 4-8-有问题，可操作 -->
            <div v-if="scope.row.serverDeployStatus == 0 || scope.row.serverDeployStatus == -1
              || (scope.row.serverDeployStatus > 3  && scope.row.serverDeployStatus < 10)">
              <div class="node-edit-wrap">
                <div
                  class="button"
                  v-if="scope.row.serverDeployStatus != -1"
                  @click="editConfig(scope.row)"
                >编辑</div>
                <!-- 已部署状态不可删除 -->
                <div
                  class="red-button"
                  v-if="scope.row.serverDeployStatus != -1"
                  @click="sureDeleteConfig(scope.row)"
                >删除</div>
                <div
                  class="button"
                  @click="sureCommitConfig(scope.row, scope.$index)"
                >提交</div>
              </div>
              <!-- <div
                v-if="scope.row.serverDeployStatus == -1"
                class="node-edit-tips margin-top-20 text-align-center"
              >{{STATUS[scope.row.serverDeployStatus]}}</div> -->
              <!-- <div
                v-if="scope.row.serverDeployStatus
                && (scope.row.serverDeployStatus > 3  && scope.row.serverDeployStatus < 10)"
                class="bonus-tips node-edit-tips margin-top-20 text-align-center"
              >问题：{{STATUS[scope.row.serverDeployStatus]}}</div> -->
            </div>
            <!-- <span
              class="node-already-wrap"
              v-else
            >
              {{STATUS[scope.row.serverDeployStatus]}}
            </span> -->
            <!-- <div
              class="button margin-left-20"
              v-if="scope.row.serverDeployStatus == 3"
              @click="showChangeBandDialog = true;updateBandServerId = scope.row.serverID"
            >修改带宽</div> -->
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="nodeConfig === 'NODATA'"
        align="left"
        empty-text="暂无数据"
        style="width: 100%"
      >
      </el-table>

      <!-- 节点提交 -->
      <el-dialog
        title="标准节点提交"
        width="65%"
        :visible.sync="showAddConfig"
        class=""
      >
        <div class="node-dialog-step node-step">
          <span class="template-title">第一步：请先选择你要提交的资源类型 </span>
          <div class="node-type-choose">
            <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">资源类型</span>
            <el-select
              v-model="serverNetType"
              placeholder="请选择"
            >
              <el-option
                key=0
                label="静态IP专线（1Gbps / 10Gbps）"
                value=0
              >
              </el-option>
              <el-option
                key=1
                label="动态IP汇聚（3Gbps - 5Gbps）"
                value=1
              >
              </el-option>
            </el-select>
          </div>
          <div class="bonus-tips margin-left-20">动态IP汇聚类型的资源需要填写拨号配置，请在软路由 - 汇聚拨号配置中填写。</div>
        </div>
        <div class="node-step node-dialog-step">
          <span class="template-title">第二步：填写服务器信息 </span>
          <div class="node-type-choose">
            <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">设备备注</span>
            <el-input
              maxlength="80"
              v-model="serverNote"
            ></el-input>
          </div>
          <div class="node-type-choose" v-if="serverNetType == '0'">
            <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title" >设备总带宽</span>
            <el-input
              maxlength="80"
              v-model="bandwidthMb"
              placeholder="只填写带宽数字，单位Mbps"
              min="1"
              type="number"
            ></el-input>
          </div>
          <div class="node-type-choose node-provider">
            <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title" >服务器提<br/>供方昵称</span>
            <el-input
              maxlength="80"
              v-model="serverOwner"
            ></el-input>
          </div>
        </div>
        <div class="node-step node-dialog-step">
          <div
            class="node-step margin-bottom-20"
            v-if="serverNetType == '0'"
          >
            <span class="template-title">第三步：填写设备登录方式</span>
            <div class="node-step3-wrap">
              <div class="item node-type-choose">
                <!-- 登陆Ip -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">设备登陆IP</span>
                  <el-input
                    maxlength="80"
                    v-model="ip"
                    placeholder="0.0.0.0"
                  ></el-input>
                </div>
                <!-- 登陆端口 -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">登陆端口</span>
                  <el-input
                    maxlength="80"
                    v-model="serverJumperPort"
                    placeholder="输入端口号，默认为22"
                    type='number'
                    min="1"
                  ></el-input>
                </div>
                <!-- 登录账号 -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">登录账号</span>
                  <el-input
                    maxlength="80"
                    v-model="serverLoginAccount"
                    placeholder="输入账号，默认为 root"
                  ></el-input>
                </div>
                <!-- 登录密码 -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">登录密码</span>
                  <el-input
                    minlength="12"
                    maxlength="20"
                    v-model="serverPasswd"
                    placeholder="请设置12位以上的复杂密码，以防被黑"
                  ></el-input>
                </div>
                <!-- 备注 -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-top-20 margin-bottom-20 step3-title">备注</span>
                  <el-input
                    maxlength="80"
                    placeholder="选填"
                    v-model="serverRecords"
                  ></el-input>
                </div>

              </div>
              <div class="item node-tips">
                <div class="recom margin-bottom-20">推荐配置：（1Gbps/10Gbps）</div>
                <div class="tips-layout">
                  <div class="tips-wrap">
                    <div class="tips">
                      <div>CPU：8核/16核（推荐 E5 2650v2）</div>
                      <div>内存：32GB/64GB</div>
                      <div>数据盘：2TB /4TB /8TB SSD （推荐 Nvme）</div>
                      <div>系统盘：100GB SSD （安装 CentOS 7.7 系统）</div>
                      <div>获取系统镜像：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-NormalNode-x86_64-v20200516.iso" class="bonus-color">点击下载</a></div>
                      <div>镜像默认密码：bonuscloud2019</div>
                      <div class="bonus-tips">注：请及时修改为复杂密码后提交，安装过程中无需进行额外操作，会有几次自动重启，时间略长，请耐心等待</div>
                    </div>
                  </div>
                </div>
                <p>  
                </p>
              </div>
            </div>
          </div>
          <div
            class="node-step margin-bottom-20"
            v-if="serverNetType == '1'"
          >
            <span class="template-title">第三步：填写设备登录方式</span>
            <div class="node-step3-wrap">
              <div class="item node-type-choose">
                <!-- 是否需要跳转 -->
                <div class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">是否需要跳转</span>
                  <el-select
                    v-model="jumperIpControl"
                    placeholder="请选择"
                  >
                    <el-option
                      key=1
                      label="是"
                      value=1
                    >
                    </el-option>
                    <el-option
                      key=2
                      label="否"
                      value=2
                    >
                    </el-option>
                  </el-select>
                <div>
                <div class="margin-top-20 bonus-tips">(若设备通过同一外网IP/域名转内网，选择开启)</div>
              </div>
              </div>
                <!-- 设备登录方式 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">设备登录方式</span>
                  <el-input
                    v-if="jumperIpControl == 1"
                    maxlength="80"
                    v-model="ip"
                    placeholder="N1 Mac/已上线主机名"
                  ></el-input>
                  <el-input
                    v-if="jumperIpControl == 2"
                    maxlength="80"
                    v-model="ip"
                    placeholder="IP/域名"
                  ></el-input>
                </div>
                <!-- 跳转内网IP -->
                <div v-if="jumperIpControl == 1" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">跳转内网IP</span>
                  <el-input
                    maxlength="80"
                    v-model="serverIntIP"
                    placeholder="IP"
                  ></el-input>
                </div>
                <!-- 远程端口 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">远程端口</span>
                  <el-input
                    v-model="serverJumperPort"
                    placeholder="只输入数字（优先映射22端口）"
                    type='number'
                    min="1"
                  ></el-input>
                </div>
                <!-- 网关地址 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">网关地址</span>
                  <el-input
                    v-model="serverGateway"
                    placeholder="IP"
                  ></el-input>
                </div>
                <!-- 登录密码 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">登录账号</span>
                  <el-input
                    maxlength="80"
                    v-model="serverLoginAccount"
                    placeholder="输入账号，默认为 root"
                  ></el-input>
                </div>
                <!-- 登录密码 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">登录密码</span>
                  <el-input
                    minlength="12"
                    maxlength="20"
                    placeholder="请设置12位以上的复杂密码，以防被黑"
                    v-model="serverPasswd"
                  ></el-input>
                </div>
                <!-- 备注 -->
                <div v-if="jumperIpControl" class="node-step-input margin-bottom-20">
                  <span class="node-type-tittle margin-right-20 step3-title">备注</span>
                  <el-input
                    maxlength="80"
                    placeholder="是否需要做多拨/是否需要做Vlan等"
                    v-model="serverRecords"
                  ></el-input>
                </div>
              </div>
              <div class="item node-tips">
                <div class="recom margin-bottom-20">汇聚必看：
                  <a
                    class="bonus-tips"
                    target="_blank"
                    href="https://shimo.im/docs/QqJtpkCkYvRTQWvx"
                  >https://shimo.im/docs/QqJtpkCkYvRTQWvx</a>
                </div>
                <div class="recom margin-bottom-20">推荐配置：（最低配置）</div>
                <!-- <NoLineTips
                  :tips="$t('mergeTips')"
                  class="dial-config-tips"
                /> -->
                <div class="tips-layout">
                  <div class="tips-wrap">
                    <div class="tips">
                      <div>CPU：16核（推荐 E5 2650v2 *2）</div>
                      <div>数据盘：4TB /8TB SSD （推荐 Nvme）</div>
                      <div>系统盘：100GB SSD （安装 CentOS 7.7 系统）</div>
                      <div>获取系统镜像：<a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-NormalNode-x86_64-v20200516.iso" class="bonus-color">点击下载</a></div>
                      <div>镜像默认密码：bonuscloud2019</div>
                      <div class="bonus-tips">注：请及时修改为复杂密码后提交，安装过程中无需进行额外操作，会有几次自动重启，时间略长，请耐心等待</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-20 node-button-wrap dial-config-footer">
          <div
            class="red-button"
            @click="showAddConfig = false"
          >取消</div>
          <div
            class="button"
            @click="commitNode"
          >保存</div>
        </div>
      </el-dialog>
      <!-- 删除Node -->
      <el-dialog
        title="提示"
        :visible.sync="showDeleteDialog"
      >
        <span>确定删除 {{dealNodeName}} 吗</span>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="showDeleteDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="deleteNode"
          >确 定</el-button>
        </span>
      </el-dialog>
      <!-- 提交配置 -->
      <el-dialog
        title="提示"
        :visible.sync="showDialDialog"
      >
        <span>确定提交 {{dealNodeName}} 的拨号配置吗</span>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="showDialDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="commitConfig"
          >确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改带宽 -->
      <el-dialog
        title="修改带宽"
        :visible.sync="showChangeBandDialog"
      >
        <div class="display-flex-center">
          <span class="margin-right-20">修改带宽: </span>
          <el-input
            maxlength="80"
            placeholder="只填写带宽数字，单位Mbps"
            min="1"
            type="number"
            v-model="updateBandWidth"
          ></el-input>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="showChangeBandDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="changeBandwidths"
          >确 定</el-button>
        </span>
      </el-dialog>
    </BasiceLayout>
  </div>
</template>

<i18n>
{
  "en": {
    "normoltTips": [
      "CPU：8核/16核（推荐 E5 2650v2）",
      "内存：32GB/64GB",
      "数据盘：2TB /4TB /8TB SSD （推荐 Nvme）",
      "系统盘：100GB SSD （安装 CentOS 7.6 系统）"
    ],
    "mergeTips": [
      "CPU：16核（推荐 E5 2650v2 *2）",
      "内存：64GB",
      "数据盘：4TB /8TB SSD （推荐 Nvme）",
      "系统盘：100GB SSD （安装 CentOS 7.6 系统）"
    ]
  }
}
</i18n>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import NoLineTips from "@/components/Common/NoLineTips.vue";
import { Message } from "element-ui";
const STATUS = {
  "-1": "拨号配置缺失",
  0: "待提交",
  1: "已提交",
  2: "部署中",
  3: "部署完成",
  4: "无法登陆",
  5: "端口不通",
  6: "拨号错误",
  7: "硬件问题",
  8: "等待官方联系", 
  9: "IP冲突", //可展示状态
  10: "部署中", //待认证，不可展示状态
  11: "部署中", //待确认，不可展示状态
  12: "部署中",
  13: "拨号修改中",
  14: "带宽修改"
};

export default {
  name: "Node",
  components: {
    BasiceLayout,
    NoLineTips
  },
  data() {
    return {
      STATUS,
      showAddConfig: false,
      serverNetType: "",
      commitType: "",
      serverNote: "", //设备备注
      bandwidthMb: "",
      serverOwner:"",//服务器提供方
      serverRecords: "", //填写备注
      ip: "",
      serverIntIP: "",
      serverPasswd: "",
      serverLoginAccount: "",
      serverJumperPort: "",
      serverGateway: "",
      hasContact: "",
      dialArray: [],
      dealNodeName: "",
      dealNodeId: "",
      dealDialId: "",
      showDeleteDialog: false,
      showDialDialog: false,
      dialConfigID: "",
      dealCIID: "",
      jumperIpControl: "",
      showChangeBandDialog: false, //修改带宽
      updateBandWidth: '', //修改带宽
      updateBandServerId: ''
    };
  },
  props: {},
  computed: mapState({
    nodeConfig: state => state.standardNode.nodeConfig,
    dialConfig: state => state.standardNode.dialConfig,
    newDialConfig: state => {
      if (
        state.standardNode &&
        state.standardNode.dialConfig &&
        state.standardNode.dialConfig.length && 
        state.standardNode.dialConfig !== 'NODATA'
      ) {
        let newConfig = state.standardNode.dialConfig.filter(
          item => item.dialStatus == 0
        );
        return newConfig;
      } else {
        return [];
      }
    },
    dialNames: state => {
      let dialName = {};

      if (
        state.standardNode &&
        state.standardNode.dialConfig &&
        state.standardNode.dialConfig.length
      ) {
        state.standardNode.dialConfig.map(item => {
          dialName[item.dialConfigID] = item.dialConfigName;
        });
      }
      return dialName;
    }
  }),

  methods: {
    ...mapActions([
      "getStandardNode",
      "setStandardNode",
      "getContact",
      "getDialConfig",
      "deleteNodeConfig",
      "setNodesDialConfig",
      "updateBand"
    ]),
    checkAdd() {
      let { hasContact } = this;
      if (!hasContact) {
        return Message({
          message: "请先前往 账号设置-联系方式 填写联系沟通方式",
          type: "error"
        });
      } else {
        this.showAddConfig = true;
        this.commitType = "ADD";
        this.serverNote = '';
        this.serverRecords = '';
        this.ip = '',
        this.serverIntIP = '';
        this.serverPasswd = '';
        this.serverLoginAccount = '';
        this.serverJumperPort = '';
        this.dialConfigID = '';
        this.dealServerId = '';
        this.bandwidthMb = '';
        this.jumperIpControl = '';
        this.serverGateway = '';
        this.serverOwner = '';
      }
    },

    //保存节点
    commitNode() {
      let {
        showAddConfig,
        serverNetType,
        commitType,
        serverNote,
        bandwidthMb,
        serverRecords,
        ip,
        serverIntIP,
        serverPasswd,
        serverLoginAccount,
        serverJumperPort,
        serverGateway,
        hasContact,
        dialConfigID,
        dealServerId,
        jumperIpControl,
        serverOwner,
      } = this;

      let data = {
        serverNetType,
        serverNote,
        bandwidthMb,
        ip,
        serverPasswd,
        serverLoginAccount,
        serverRecords,
        commitType,
        dialConfigID,
        serverID: dealServerId,
        serverJumperPort,
        serverGateway,
        serverOwner
      };

      if (serverNetType == 1) {
        if (jumperIpControl == 1) {
          data.serverIntIP = serverIntIP;
        }
      }

      // 动态网关地址判断
      if (serverNetType == 1 && !serverGateway) {
        return Message({
          message: "缺少网关地址",
          type: "error"
        });
      }

      if (
          !serverNote ||
          !serverNetType ||
          !ip ||
          !serverPasswd ||
          !serverLoginAccount ||
          !serverOwner ||
          ( serverNetType == 0 && !bandwidthMb )
        ) {
        return Message({
          message: "缺少参数",
          type: "error"
        });
      }

      if (serverJumperPort && isNaN(serverJumperPort) || serverJumperPort < 0) {
        return Message({
          message: "请输入正确的端口",
          type: "error"
        });
      }
      
      // 防止多次操作
      const loading = this.$loading({
        lock: true,
        text: 'loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.setStandardNode(data).then(res => {
        loading.close();
        if (res.status === 200) {
          Message({
            message: "保存成功",
            type: "success"
          });
          this.getStandardNode();
          this.showAddConfig = false;
        } else {
          Message({
            message: res.message || '网络问题，请重试',
            type: "error"
          });
        }
      });
    },
    editConfig(item) {
      let dealServerId = item.serverID;
      this.commitType = "EDIT";
      this.showAddConfig = true;
      this.dealServerId = item.serverID;

      this.getStandardNode({ serverID: dealServerId }).then(res => {
        this.serverID = res.serverID;
        this.serverNetType = String(res.serverNetType);
        this.serverNote = res.serverNote;
        this.bandwidthMb = res.bandwidthMb;
        this.ip = res.serverJumperIP || res.serverExtIP;
        this.serverLoginAccount = res.serverLoginAccount;
        this.serverPasswd = res.serverPasswd;
        this.serverIntIP = res.serverIntIP;
        this.serverJumperPort = res.serverJumperPort;
        this.serverGateway = res.serverGateway;
        this.serverRecords = res.serverRecords;
        this.jumperIpControl = res.serverIntIP ? "1" : "2";
        this.serverOwner = res.serverOwner;
      });
    },
    sureDeleteConfig(item) {
      this.dealNodeId = item.serverID;
      this.dealCIID = item._id;
      this.dealNodeName = item.serverNote;
      this.showDeleteDialog = true;
    },
    deleteNode() {
      let dealCIID = this.dealCIID;
      console.log({serverCIID: dealCIID})
      // 防止多次操作
      const loading = this.$loading({
        lock: true,
        text: 'loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.deleteNodeConfig({ serverCIID: dealCIID }).then(res => {
        loading.close();
        if (res.status === 200) {
          Message({
            message: "删除成功",
            type: "success"
          });
          this.showDeleteDialog = false;
          this.getStandardNode();
        } else {
          Message({
            message: res.message || '网络问题，请重试',
            type: "error"
          });
        }
      });
    },
    //提交节点
    sureCommitConfig(item, index) {
      this.dealNodeName = item.serverNote;
      this.dealDialId = this.dialArray[index];
      this.dealNodeId = item.serverID;

      this.getContact().then(res => {
        if ( res.data.contact == "18401695453") {
          this.showDialDialog = true;
        } else if (item.serverNetType == 1){
          if(!this.dialArray[index]) {
            return Message({
              message: "请先选择拨号配置",
              type: "error"
            });
          }
          //动态提交带宽为拨号配置单线和、静态为用户填写输入的
          //动态在提交节点时（完成拨号配置）提交带宽、静态在添加节点时提交
          const selectDial = this.newDialConfig.filter((item)=>{
            if(item.dialConfigID === this.dialArray[index]) {
              return item;
            }
          })
          this.bandwidthMb = selectDial[0].dialBandwidths;
          this.showDialDialog = true;
        } else {
          this.showDialDialog = true;
        }
      })
    },
    //确定提交节点
    commitConfig() {
      let { dealDialId, dealNodeId,bandwidthMb } = this;

      this.setNodesDialConfig({
        dialConfigID: dealDialId,
        serverID: dealNodeId,
        bandwidthMb,
      }).then(res => {
        if (res.code === 200) {
          Message({
            message: "设置成功",
            type: "success"
          });
          this.getStandardNode();
          this.showDialDialog = false;
        } else {
          Message({
            message: res.message || '网络问题，请重试',
            type: "error"
          });
        }
      });
    },
    // 修改带宽
    changeBandwidths(item) {
      let { updateBandWidth, updateBandServerId } = this;
      this.updateBand({updateBandWidth, updateBandServerId}).then(res => {
        if (res.code === 200) {
          Message({
            message: "更新成功",
            type: "success"
          });
          this.showChangeBandDialog = false;
        } else {
          Message({
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  created() {
    this.getStandardNode();
    this.getDialConfig({ configed: true });
    this.getContact().then(res => {
      if (res.data && res.data.contact) {
        this.hasContact = true;
      } else {
        this.hasContact = false;
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.node-type-choose {
  margin: 20px;
}

.node-provider {
  display: flex;
  align-items: center;
}

.hard-node .dial-input.el-select, .hard-node .dial-input .el-input {
  width: 120px;
}

.hard-node .el-input {
  width: 230px;
  display: inline-block;
}

.hard-node .el-select {
  max-width: 100px !important;
}

.node-step3-wrap {
  display: flex;

  .item {
    width: 50%;
  }

  .node-tips {
    margin: 20px;
  }
}

.node-type-tittle {
  display: inline-block;
  max-width: 200px;
  min-width: 100px;
}

.node-edit-wrap {
  display: flex;
}

.node-dialog-step {
  margin: 20px 30px 60px;
  text-align: left;
}

.node-button-wrap {
  display: flex;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.hard-wrap .el-dialog__header {
  text-align: center;
  font-size: 28px;
}

.hard-wrap .el-dialog__title {
  font-size: 26px;
}
</style>